import { InputLabel, Stack, Tooltip } from "@mui/material";
import { useCreateApiCall } from "hooks/useCreateApiCall";
import { required } from "models/validations";
import { useEffect, useState } from "react";
import { useAppDispatch } from "store/hooks";
import { FormTextField } from "UI/FormTextField";
import { showError } from "store/reducers/errorReducer";

export const Captcha = ({ control, setValue }) => {
  const { createApiCall } = useCreateApiCall();
  const dispatch = useAppDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const [captchaId, setCaptchaId] = useState("");

  const generateSecurityCodeImage = createApiCall(
    async () => {
      let result;
      setIsLoaded(false);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/get_captcha`,
          {
            method: "GET",
          }
        );
        result = await response.json();
      } catch (error) {
        dispatch(showError(error));
        return;
      }

      if (!result || result?.error) {
        dispatch(
          showError(
            result?.error ?? "Something went wrong. Try to reload the page."
          )
        );
        return;
      }

      setValue("captchaId", result?.captchaId);
      setCaptchaId(result?.captchaId);
      setIsLoaded(true);
    },
    undefined,
    true
  );

  useEffect(() => {
    generateSecurityCodeImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack alignItems={"stretch"}>
      <InputLabel sx={{ alignSelf: "flex-start" }} htmlFor="firstName">Verification Code</InputLabel>
      <Stack direction={"row"} alignItems={"flex-start"} gap={1}>
        <FormTextField
          id="code"
          name="code"
          control={control}
          rules={{ required }}
          InputProps={{
            autoComplete: "off",
          }}
        />
        <div className="rounded-md border flex flex-col justify-center items-center border-gray-200 border-solid w-36 h-10">
          {isLoaded && captchaId ? (
            <Tooltip title="Click to refresh the code">
              <img
                src={`${process.env.REACT_APP_API_V2_URL}/public/captcha/${captchaId}`}
                style={{
                  objectFit: "contain",
                  width: "100px",
                  height: "36px",
                  cursor: "pointer",
                }}
                alt="code"
                onClick={generateSecurityCodeImage}
              />
            </Tooltip>
          ) : (
            <div className="text-sm text-gray-400">Loading...</div>
          )}
        </div>
      </Stack>
    </Stack>
  );
};
